import styled from 'styled-components';

export const BrandIdentityStyles = styled.div`
  font-family: 'Montserrat';
  position: relative;
  overflow: hidden;

  .bannerDescription {
    max-width: 1190px;
  }

  .container {
    max-width: 1190px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
    margin: 0 auto;
    position: relative;

    @media (max-width: 991px) {
      flex-direction: column;
      gap: 15px;
    }

    h5 {
      font-weight: 700;
      font-size: 18px;
      line-height: 120%;
      background: var(--Brand-identity, linear-gradient(225deg, #FFBD14 0%, #DB9000 100%));
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    h2 {
      font-weight: 700;
      font-size: 40px;
      line-height: 120%;
      color: #000000;

      @media (max-width: 768px) {
        font-size: 28px;
      }
    }

    .content {
      max-width: 770px;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      position: relative;
      gap: 50px;
      z-index: 2;

      @media (max-width: 991px) {
        gap: 25px;
        max-width: none;
      }
    }
  }

  .btn-container {
    display: flex;
    width: 100%;
    justify-content: center;
  }
`;
